// extracted by mini-css-extract-plugin
export default {"dropdownTitle":"ufmQt_","expanded":"X4kpf_","arrow":"D0KHS6","text":"xX1Par","searchFadeIn":"dw0C51"};